import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ILocation } from 'src/app/services/location/location.service';

@Injectable({
  providedIn: 'root'
})
export class LocationStoreService {
  public locations$: BehaviorSubject<any> = new BehaviorSubject([]);
  public currLocation$: BehaviorSubject<ILocation> = new BehaviorSubject({});
  public allLocations = {}
  
  constructor() { }

  get getLocations() {
    return this.locations$.getValue();
  }

  set setLocations(data) {
    this.locations$.next(data);
  }

  set pushLocations(data) {
    this.locations$.next([...this.locations$.getValue(), data]);
  }

  get currentLocation() {
    return this.currLocation$.value;
  }

  set setCurrentLocation(data) {
    this.currLocation$.next(data);
  }

  clearDataService() {
    this.locations$ = new BehaviorSubject([]);
    this.currLocation$ = new BehaviorSubject({});
  }
}
